import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';
import moment from 'moment';
import intlShape from '@/shared/utils/intlShape';
import messages from '../budgetMessages';

const currentYear = moment.utc().year();

export default class UpdateBudgetAmountModal extends Component {
  state = {
    overrideBudget: false,
    referenceYear: currentYear,
    budgetYear: currentYear + 1,
    years: [],
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    year: PropTypes.number, // Year from filters
  };
  static defaultProps = {
    year: null,
  };
  componentDidMount() {
    const { year } = this.props;
    const referenceYear = year || moment.utc().year();
    const budgetYear = referenceYear + 1;

    const years = [
      budgetYear + 2,
      budgetYear + 1,
      budgetYear,
      budgetYear - 1,
      budgetYear - 2,
      budgetYear - 3,
    ];
    this.setState({ referenceYear, budgetYear, years });
  }

  isFormInvalid = () => {
    const { referenceYear, budgetYear } = this.state;
    if (!referenceYear || referenceYear < 2000) return true;
    if (!budgetYear || budgetYear < 2000) return true;
    if (referenceYear === budgetYear) return true;

    return false;
  };

  onSave = () => {
    const { overrideBudget, referenceYear, budgetYear } = this.state;

    const { onSave } = this.props;

    const amountUpdate = {
      overrideBudget,
      referenceYear,
      budgetYear,
    };

    return onSave(amountUpdate);
  };

  toggleCheckbox = name => {
    if (!name) return;
    this.setState(({ [name]: oldValue }) => ({ [name]: !oldValue }));
  };

  referenceYearChanged = e => {
    const referenceYear = parseInt(e.target.value) || null;

    this.setState(({ budgetYear }) => ({
      referenceYear,
      budgetYear: budgetYear === referenceYear ? referenceYear + 1 : budgetYear,
    }));
  };
  budgetYearChanged = e => {
    const budgetYear = parseInt(e.target.value) || null;

    this.setState({
      budgetYear,
    });
  };

  render() {
    const { show, onClose, intl, year } = this.props;
    const { overrideBudget, referenceYear, budgetYear, years } = this.state;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.CopyBudget)}
        show={show}
        onClose={onClose}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <label className="control-label col-sm-3">
              {intl.formatMessage(messages.BudgetBasedOnYear)}
            </label>
            <div className="col-sm-8">
              {year && year >= 2000 ? (
                <Fragment>
                  <p className="form-control-static">{year}</p>
                  <p className="text-info">
                    {intl.formatMessage(messages.CopyBudgetYearFilterInfo)}
                  </p>
                </Fragment>
              ) : (
                <select
                  className="form-control"
                  value={referenceYear || ''}
                  onChange={this.referenceYearChanged}
                >
                  {years.map(y => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-3">
              {intl.formatMessage(messages.CopyBudgetToYear)}
            </label>
            <div className="col-sm-8">
              <select
                className="form-control"
                value={budgetYear || ''}
                onChange={e => this.setState({ budgetYear: parseInt(e.target.value) || null })}
              >
                {years
                  .filter(y => y !== referenceYear)
                  .map(y => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="form-group">
            <Checkbox
              extraClass="col-sm-offset-3 col-md-8"
              id="overrideBudget"
              value={overrideBudget}
              onClick={() => this.setState({ overrideBudget: !overrideBudget })}
              text={intl.formatMessage(messages.OverrideIfBudgetExists)}
            />
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
